import { getItem } from '../../utils/localStorage';

export const filterUnreadNotifications = (notifications) =>
  notifications.filter((notification) => !notification.isRead);

const CTAStringHighlights = ['click to view', 'click to review'];

export const checkNotificationClickAnalizer = (notification: any) => {
  const notificationBody = notification.body.toLowerCase();
  if (
    CTAStringHighlights.some((highlight) =>
      notificationBody.includes(highlight)
    )
  ) {
    const navigationParams = getNotificationNavigationActionPath(notification);
    return { ...notification, clickable: true, navigationParams };
  }
  return { ...notification, clickable: false };
};

const getNotificationNavigationActionPath = (notification: any) => {
  const userData = getItem('user');
  switch (notification.type) {
    case 'selfAssessment':
      return [
        '/editSelfAssessment',
        { state: { assessmentId: notification.assessmentId, isSelf: true } },
      ];
    case 'actionPlan':
      const evnt =
        userData.user.id === notification.sentByUserId ? 'sent' : 'received';
      return [
        `/editActionPlan/from-individual/${evnt}/${notification.actionPlanId}`,
      ];
    default:
      break;
  }
  return;
};
